import { useState } from "react";
import { Modal, Button } from "antd";

import * as S from "./styles";

export const UpdateBannerModal = ({ open, onCancel, onSubmit, title }) => {
  const [selectedFiles, setSelectedFiles] = useState({
    desktop: null,
    mobile: null
  });

  const handleOnChangeFile = (type) => (e) => {
    const file = e.target.files[0];
    setSelectedFiles(prev => ({...prev, [type]: file}));
  };

  const handleUpload = async () => {
    await onSubmit({
      desktop: selectedFiles.desktop,
      mobile: selectedFiles.mobile
    });
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      cancelText="Cancelar"
      destroyOnClose={true}
      closable={false}
      okButtonProps={{
        style: {
          display: "none",
        },
      }}
    >
      <S.Container>
        <div style={{ marginBottom: 24 }}>
          <h4>Banner Desktop:</h4>
          <input
            type="file"
            onChange={handleOnChangeFile('desktop')}
            accept="image/*"
          />
        </div>

        <div style={{ marginBottom: 24 }}>
          <h4>Banner Mobile:</h4>
          <input
            type="file"
            onChange={handleOnChangeFile('mobile')}
            accept="image/*"
          />
        </div>

        <Button
          type="primary"
          onClick={handleUpload}
          disabled={!selectedFiles.desktop && !selectedFiles.mobile}
          id="app-button"
        >
          Enviar
        </Button>
      </S.Container>
    </Modal>
  );
};
